module.exports = __webpack_public_path__ + "img/8.8b81979e.png";